import React from 'react'
import Layout from './Layout'

export const UserReports = () => <Layout />
